// extracted by mini-css-extract-plugin
export default {"r_l":"d22e35e967 _47c080a5d7","t":"c7f36f96a2"};